import gql from "graphql-tag";

export const SCRAP_WEBSITE = gql`
  mutation Mutation($payload: CreateScrapyInput!) {
    ScrapUrl(payload: $payload) {
      id
      sessionId
      authorId
    }
  }
`;

export const pageSpeed = gql`
  mutation Mutation($data: ScrapyReportInputs!) {
    PageSpeed(data: $data) {
      projectId
      sessionId
      userId
      website
      mobileSpeed
      mobilejson
      desktopSpeed
      desktopjson
      id
      issues
      notices
      updatedAt
      warnings
      createdAt
    }
  }
`;

export const ligtHouseSave = gql`
  mutation Mutation($projectId: String!, $sessionId: String!) {
    lightHouseReport(projectId: $projectId, sessionId: $sessionId)
  }
`;
export const pauseLighthouseReport = gql`
  mutation Mutation($projectId: String!, $sessionId: String!) {
    pauseLightHouseReport(projectId: $projectId, sessionId: $sessionId)
  }
`;
export const resumeLighthouseReport = gql`
  mutation Mutation($projectId: String!, $sessionId: String!) {
    resumeLightHouseReport(projectId: $projectId, sessionId: $sessionId)
  }
`;
export const CHECK_METADATA_N_TITLE = gql`
  mutation CheckMetaDataAndTitle($inputArg: TitleMetaDTO!) {
    checkMetaDataAndTitle(inputArg: $inputArg) {
      meta_description
      title
    }
  }
`;
export const GENERATE_METADATA_N_TITLE = gql`
  mutation Mutation($payload: GenerateInputs!) {
    generateMetaDataAndTitle(payload: $payload) {
      meta_description
      title
    }
  }
`;

export const scrapeSearchResults = gql`
  query ScrapeSearchResults($data: ScrapeResultInput!) {
    scrapeSearchResults(data: $data) {
      _id
      contentScore
      domainAuthority
      googleRank
      rank
      title
      url
      wordCount
    }
  }
`;

export const analyseBlogandScore = gql`
  query AnalyseBlogandScore($content: AnalyseBlogandScoreInput!) {
    analyseBlogandScore(content: $content) {
      entities {
        name
        salience
        type
      }
      headingsScore
      notes
      overallScore
      termAnalysis {
        basic {
          expectedCount
          originalCount
          term
        }
        extended {
          expectedCount
          originalCount
          term
        }
      }
      termsCoverage
      titleAccuracy
      wordsCurrent
      wordsTarget
    }
  }
`;

export const getContentQueriesByUserId = gql`
  query GetContentQueriesByUserId {
    getContentQueriesByUserId {
      _id
      content_competition
      content_score
      createdAt
      queryName
      updatedAt
      userId
      wordsCount
      status
      projectMode
      projectHomepage
      projectName
    }
  }
`;

export const createContentquery = gql`
  mutation CreateContentQuery($queryName: String!) {
    createContentQuery(queryName: $queryName) {
      _id
      queryName
    }
  }
`;

export const getContentQueryById = gql`
  query GetContentQueryById($queryId: String!) {
    getContentQueryById(queryId: $queryId) {
      # BasicKeywords {
      #   expectedCount
      #   name
      #   originalCount
      # }
      # ExtendedKeywords {
      #   expectedCount
      #   name
      #   originalCount
      # }
      HeadingBasicKeywords {
        name
        expectedCount
        originalCount
      }
      HeadingExtendedKeywords {
        name
        expectedCount
        originalCount
      }
      ArticleBasicKeywords {
        name
        expectedCount
        originalCount
      }
      ArticleExtendedKeywords {
        name
        expectedCount
        originalCount
      }
      _id
      competitors {
        _id
        contentScore
        domainAuthority
        googleRank
        isSelected
        rank
        title
        url
        wordCount
      }
      content_competition
      content_score
      createdAt
      headingsScore
      metaDescription
      htmlBlogDescription
      queryName
      selectedByUser
      termsCoverage
      title
      titleAccuracy
      updatedAt
      userId
      wordsCount
      projectMode
      projectHomepage
      projectName
      location
      plannerKeywords {
        keyword
        monthlySearches
        competition
        competitorTitle
      }
      imageHistory {
        h2Id
        heading
        currentUrl
        urls
      }
      entities {
        keyword
        wikiUrl
      }
    }
  }
`;

// export const updateSelectedCompetitorsAddKeywords = gql`
//   mutation UpdateSelectedCompetitorsAddKeywords($data: UpdateCompetitorsInput!) {
//     updateSelectedCompetitorsAddKeywords(data: $data) {
//       BasicKeywords {
//         expectedCount
//         name
//         originalCount
//       }
//       ExtendedKeywords {
//         expectedCount
//         name
//         originalCount
//       }
//       _id
//       competitors {
//         _id
//         contentScore
//         domainAuthority
//         googleRank
//         isSelected
//         rank
//         title
//         url
//         wordCount
//       }
//       content_competition
//       content_score
//       createdAt
//       headingsScore
//       htmlBlogDescription
//       queryName
//       selectedByUser
//       termsCoverage
//       title
//       titleAccuracy
//       updatedAt
//       userId
//       wordsCount
//     }
//   }
// `;
export const updateSelectedCompetitorsAddKeywords = gql`
  mutation UpdateSelectedCompetitorsAddKeywords($data: UpdateCompetitorsInput!) {
    updateSelectedCompetitorsAddKeywords(data: $data) {
      _id

      HeadingBasicKeywords {
        name
        expectedCount
        originalCount
      }
      HeadingExtendedKeywords {
        name
        expectedCount
        originalCount
      }
      ArticleBasicKeywords {
        name
        expectedCount
        originalCount
      }
      ArticleExtendedKeywords {
        name
        expectedCount
        originalCount
      }

      plannerKeywords {
        keyword
        monthlySearches
        competition
        competitorTitle
      }
      location

      competitors {
        _id
        contentScore
        domainAuthority
        googleRank
        isSelected
        rank
        title
        url
        wordCount
      }

      content_competition
      content_score
      createdAt
      headingsScore
      htmlBlogDescription
      queryName
      selectedByUser
      termsCoverage
      title
      titleAccuracy
      updatedAt
      userId
      wordsCount
    }
  }
`;

export const generateTitle = gql`
  query Query($queryId: String!) {
    generateTitleByQueryId(queryId: $queryId)
  }
`;

export const GENERATE_META_DESCRIPTION_BY_QUERY_ID = gql`
  query GenerateMetaDescriptionByQueryId($queryId: String!) {
    generateMetaDescriptionByQueryId(queryId: $queryId)
  }
`;

export const GENERATE_KEYWORD_SENTENCE = gql`
  query GenerateKeywordSentence($queryId: String!, $keyword: String!) {
    generateKeywordSentence(queryId: $queryId, keyword: $keyword)
  }
`;

export const GENERATE_KEYWORD_IN_CONTEXT = gql`
  query GenerateKeywordInContext($queryId: String!, $keyword: String!, $selectedText: String!) {
    generateKeywordInContext(queryId: $queryId, keyword: $keyword, selectedText: $selectedText)
  }
`;

export const updateTitle = gql`
  mutation UpdatetitleByQueryId($data: updatetitleByQueryIdInput!) {
    updatetitleByQueryId(data: $data) {
      title
    }
  }
`;

export const updateHtmlDescription = gql`
  mutation UpdateBlogDescriptionById($data: updateBlogDescriptionByIdInput!) {
    updateBlogDescriptionById(data: $data) {
      BasicKeywords {
        expectedCount
        name
        originalCount
      }
      ExtendedKeywords {
        expectedCount
        name
        originalCount
      }
      _id
      competitors {
        _id
        contentScore
        domainAuthority
        googleRank
        isSelected
        rank
        title
        url
        wordCount
      }
      content_competition
      content_score
      createdAt
      headingsScore
      htmlBlogDescription
      queryName
      selectedByUser
      termsCoverage
      title
      titleAccuracy
      updatedAt
      userId
      wordsCount
      wordsTarget
    }
  }
`;

export const generateParagraph = gql`
  query Query($data: createBlogByAiInput!) {
    generateBlogDescriptionById(data: $data)
  }
`;

export const analyseAndUpdateBlog = gql`
  mutation AnalyseAndUpdateBlog($data: AnalyseBlogandScoreInput!) {
    analyseAndUpdateBlog(data: $data) {
      _id
      queryName
      content_competition
      content_score
      wordsCount
      title
      htmlBlogDescription
      updatedAt
      metaDescription
    }
  }
`;

export const GENERATE_OUTLINE = gql`
  mutation GenerateOutline($data: generateOutlineInput!) {
    generateOutline(data: $data)
  }
`;

export const GENERATE_ARTICLE_FROM_OUTLINE = gql`
  mutation GenerateArticleFromOutline($data: generateArticleFromOutlineInput!) {
    generateArticleFromOutline(data: $data)
  }
`;

// added for saving meta description in the db
export const UPDATE_META_DESCRIPTION = gql`
  mutation UpdateMetaDescription($data: updateMetaDescriptionByQueryIdInput!) {
    updateMetaDescriptionByQueryId(data: $data) {
      _id
      metaDescription
    }
  }
`;

// newly added mutation for updating content query status
export const UPDATE_CONTENT_QUERY_STATUS = gql`
  mutation UpdateContentQueryStatus($queryId: String!, $status: String!) {
    updateContentQueryStatus(queryId: $queryId, status: $status) {
      _id
      status
    }
  }
`;

// newly added mutation for deleting content query
export const DELETE_CONTENT_QUERY = gql`
  mutation DeleteContentQueryById($queryId: String!) {
    deleteContentQueryById(queryId: $queryId)
  }
`;

export const REGENERATE_UNSPLASH_IMAGE = gql`
  mutation RegenerateUnsplashImage($query: String!) {
    regenerateUnsplashImage(query: $query)
  }
`;

export const REGENERATE_PEXELS_IMAGE = gql`
  mutation RegeneratePexelsImage($query: String!) {
    regeneratePexelsImage(query: $query)
  }
`;

export const SELECT_SECTION_IMAGE = gql`
  mutation SelectSectionImage($data: selectSectionImageInput!) {
    selectSectionImage(data: $data) {
      _id
      imageHistory {
        h2Id
        heading
        currentUrl
        urls
      }
    }
  }
`;

export const ADD_IMAGE_TO_HISTORY = gql`
  mutation AddImageToHistory($data: addImageToHistoryInput!) {
    addImageToHistory(data: $data) {
      _id
      imageHistory {
        h2Id
        heading
        currentUrl
        urls
      }
    }
  }
`;

export const GENERATE_INTERNAL_LINKS = gql`
  mutation GenerateInternalLinks($data: InternalLinkInput!) {
    generateInternalLinks(data: $data) {
      sentence
      anchor
      url
    }
  }
`;

export const UPDATE_PROJECT_SETTINGS = gql`
  mutation UpdateProjectSettings($data: UpdateProjectSettingsInput!) {
    updateProjectSettings(data: $data)
  }
`;

// gives the latest project_id for the internal links
export const GET_LATEST_PROJECT_ID = gql`
  mutation GetLatestProjectId($domain: String!) {
    GetLatestProjectId(domain: $domain)
  }
`;

export const GENERATE_ENTITIES = gql`
  mutation GenerateEntitiesFromContent($queryId: String!, $html: String!) {
    generateEntitiesFromContent(queryId: $queryId, html: $html) {
      keyword
      wikiUrl
    }
  }
`;

// ── Content Calendar ─────────────────────────────────────────────────────────

export const SCHEDULE_POST = gql`
  mutation SchedulePost($input: SchedulePostInput!) {
    schedulePost(input: $input)
  }
`;

export const CANCEL_SCHEDULED_POST = gql`
  mutation CancelScheduledPost($postId: String!) {
    cancelScheduledPost(postId: $postId)
  }
`;

export const RESCHEDULE_POST = gql`
  mutation ReschedulePost($postId: String!, $publishAt: String!) {
    reschedulePost(postId: $postId, publishAt: $publishAt)
  }
`;
